
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/login",
      function () {
        return require("private-next-pages/partners/login.js");
      }
    ]);
  